import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
	container: {
		maxWidth: 1000,
		width: '90%',
		margin: '0 auto',
	},
	wrapper: {
		paddingTop: '4vh',
		width: '100%',
		margin: '0 auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},

	subtitle: {
		maxWidth: 700,
		fontSize: 40,
		fontWeight: 600,
		margin: '20px 0',
		textAlign: 'center',
		[theme.breakpoints.down('sm')]: {
			lineHeight: '132%',
			maxWidth: '70%',
			fontSize: 24,
			fontWeight: 500,
			margin: 0,
		},
	},
	subtitle2: {
		[theme.breakpoints.down('sm')]: {
			marginTop: 7,
			lineHeight: '24px',
			fontSize: 16,
			fontWeight: 400,
		},
	},
	mt: {
		marginTop: 200,
	},
	grid: {
		margin: '50px 0',
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
	},
	link: {
		textDecoration: 'none',
		width: '100%',
		textAlign: 'center',
	},
	startButton: {
		width: 500,
		padding: '20px 0 15px',
		fontSize: 24,
		borderRadius: 15,
		marginBottom: 20,
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			padding: '16px 10px',
			maxHeight: 48,
			fontSize: 16,
		},
	},
	imgContainer: {
		margin: '100px 0',
		width: '100vw',
		[theme.breakpoints.down('sm')]: {
			margin: '65px 0',
		},
	},
	heroImg: {
		maxWidth: '90%',
		transform: `scaleX(${theme.direction === 'ltr' ? 1 : -1})`,
	},
	headerBtn: {
		marginLeft: theme.spacing(2),
		fontSize: 24,
		paddingLeft: 30,
		paddingRight: 30,
		height: '100%',
		maxHeight: 60,
		[theme.breakpoints.down('sm')]: {
			maxHeight: 43,
			paddingLeft: 20,
			paddingRight: 20,
			fontSize: 18,
		},
	},
	errorWrapper: {
		position: 'absolute',
		top: '10vh',
		left: 0,
		right: 0,
	},
}));
